import { IZone } from '../custom/classes/production';


export function sumPrices(zone: IZone, priceTypeQuantities: Map<number, number>) {
    let prices = [];
    let foundAllPriceTypes = true;
    priceTypeQuantities.forEach((quantity, ptId) => {
        const matchedPrice = zone.prices.filter(pr => pr.priceTypeId === ptId);
        if (matchedPrice.length > 0) {
            var i;
            for (i = 0; i < quantity; i++) {
                prices.push(matchedPrice.map(pr => pr.price).reduce((total, num) => total + num, 0));
            }
        }
        else {
            foundAllPriceTypes = false;
        }
    });

    const priceSum = prices.reduce((total, num) => total + num, 0);
    return { priceSum, foundAllPriceTypes };
}


